import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7bfdb1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-con" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "paper-tag" }
const _hoisted_4 = { class: "m-count" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-seperator" }, "·", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-seperator" }, "·", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "u-btn" }, "查看")
], -1))

import dayjs from 'dayjs';
    import { IPaperItem } from '@/interface/paper';   
    import { computed, Ref } from 'vue';
    import { PaperViewFrom } from '@/const/paper';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PaperItem',
  props: {
        data: {
            type: Object,
            default: () => ({} as IPaperItem),
        },
        from: {
            type: Number,
            default: PaperViewFrom.SEARCHLIST,
        },
        time: {
            type: String,
            default: '',
        },
    },
  emits: ['onItemClick'],
  setup(__props, { emit: emits }) {

const props = __props;

    
    

    const targetDetail = () => {
        console.log(paperData.value, 'paperData.value')
        emits('onItemClick', paperData.value)
    }
    const time = computed(() => props.time)
    const paperData = computed((): IPaperItem => {
        const { paper_type = 0, type = '', create_time, timestamp } = (props.data || {}) as IPaperItem
        console.log(props?.time, '---------')
        return {
            ...props.data,
            paper_type: !(paper_type || type) ? 1 : paper_type || (type === 'SGPE' ? 1 : 2) || 1,
            create_time: props?.time || (timestamp && typeof timestamp === 'number' ? dayjs.unix(timestamp).format('YYYY-MM-DD') : create_time ? dayjs((typeof create_time === 'number' ? create_time * 1000 : create_time)).format('YYYY-MM-DD') : ''),
        } as IPaperItem
    })

return (_ctx: any,_cache: any) => {
  return (paperData.value?.name || paperData.value?.id || paperData.value?.paper_id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "paper-item",
        onClick: targetDetail
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["u-icon", paperData.value?.paper_type === 1 ? 'single-paper' : 'multi-paper'])
        }, null, 2),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(paperData.value?.name || ''), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paperData.value.tags_info || [], (item) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "tag-tile",
                key: item.tag_key
              }, _toDisplayString(item?.tag_name), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (time.value || paperData.value?.create_time)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(time.value || paperData.value.create_time) + " " + _toDisplayString(__props.from === _unref(PaperViewFrom).MINE ? '获得' : ''), 1),
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(paperData.value.views) + "浏览", 1),
            (paperData.value?.que_num)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(paperData.value.que_num || 0) + "题", 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_7
      ]))
    : _createCommentVNode("", true)
}
}

})